<template>
    <div class="tco-tool__popout-grid-models-container">
        <div class="tco-tool__popout-grid">
            <div class="tco-tool__popout-grid-controls">
                <button type="button" class="btn btn--fake-link link link--secondary link--has-icon-reverse tco-tool__popout-grid-back" @click="back">Back</button>
                <h2 class="tco-tool__popout-grid-title" v-if="isElectric">Please select an electric vehicle</h2>
                <h2 class="tco-tool__popout-grid-title" v-else>Compare to</h2>
            </div>

            <PopoutGridModels :is-electric="isElectric" :brand="brand" v-on:model-selected="scrollToTrims" :class="{'tco-tool__popout-grid-models--open': step == 1}"></PopoutGridModels>

            <div class="tco-tool__popout-grid-separator"></div>

            <div class="tco-tool__popout-grid-right" :class="{'tco-tool__popout-grid-right--open': step == 2}">
                <PopoutGridTrims :is-electric="isElectric" :brand="brand"></PopoutGridTrims>
                <PopoutGridEngines :is-electric="isElectric"></PopoutGridEngines>
            </div>

            <div class="tco-tool__popout-grid-actions" :class="{'tco-tool__popout-grid-actions--open': step == 2}">
                <button type="button" class="btn btn--primary btn--full-width-xs" :disabled="!selectedModel" @click="closeSelector">Select this vehicle</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import PopoutGridModels from "./PopoutGridModels.vue";
import PopoutGridTrims from './PopoutGridTrims.vue';
import PopoutGridEngines from "./PopoutGridEngines.vue";

export default {
    components: {
        PopoutGridModels,
        PopoutGridTrims,
        PopoutGridEngines
    },
    props: {
        brand: {
            required: true,
            type: Object
        },
        isElectric: {
            required: false,
            default: false,
        }
    },
    data() {
        return {
            step: 1
        };
    },
    methods: {
        closeSelector() {
            this.$emit('close-selector', this.model);
            this.step = 1;
        },
        back() {
            if (this.step == 2) {
                this.step = 1;
                return;
            }
            this.closeSelector();
        },
        scrollToTrims() {
            this.step = 2;
        }
    },
    computed: {
        ...mapState(['selectedEvModel', 'selectedIceModel']),
        selectedModel() {
            if (this.isElectric) {
                return this.selectedEvModel;
            }
            return this.selectedIceModel;
        },
    },
}
</script>